import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import DeliveryOptions from 'components/ProductPage/DeliveryOptions';
import FulfillmentMethods from 'components/ProductPage/FulfillmentMethods';
import DeliveryFrequencyModal from 'components/GlobalModals/DeliveryFrequencyModal';
import ProductViewsCount from 'components/ProductPage/ProductViewsCount';
import MediaUtils from 'utils/Media';
import localeUtils from 'utils/LanguageLocale';
import AutoReplenishmentEN from 'components/DeliveryInfo/AutoReplenishment/locales/AutoReplenishment_en_US';
import AutoReplenishmentFR from 'components/DeliveryInfo/AutoReplenishment/locales/AutoReplenishment_fr_CA';
import { showPdpFulfillmentSelectorSelector } from 'viewModel/selectors/testTarget/showPdpFulfillmentSelectorSelector';

const { Media } = MediaUtils;
const getAutoReplenText = localeUtils.getLocalisedDataFromResource(AutoReplenishmentEN, AutoReplenishmentFR);

const FulfillmentSection = ({
    currentProduct, fulfillment, commerce, isExternallySellable, displayOrderCutoffCountdown, showSocialProofPDP
}) => {
    const currentSku = currentProduct?.currentSku;
    const showFulfillmentMethodsRedesign = useSelector(showPdpFulfillmentSelectorSelector);

    if (isExternallySellable) {
        return null;
    }

    return (
        <>
            {showFulfillmentMethodsRedesign ? (
                <FulfillmentMethods
                    currentProduct={currentProduct}
                    fulfillment={fulfillment}
                    commerce={commerce}
                    displayOrderCutoffCountdown={displayOrderCutoffCountdown}
                />
            ) : (
                <DeliveryOptions
                    displayOrderCutoffCountdown={displayOrderCutoffCountdown}
                    getItShipped={fulfillment.selectedMethod === 'shipped'}
                    getItShippedClick={fulfillment.selectShipped}
                    sameDayDelivery={fulfillment.selectedMethod === 'sameday'}
                    sameDayDeliveryClick={fulfillment.selectSameDay}
                    serviceUnavailable={fulfillment.serviceUnavailable}
                    sameDayNotAvailableForZip={fulfillment.sameDayNotAvailableForZip}
                    sameDayAvailable={fulfillment.sameDayAvailable}
                    currentProduct={currentProduct}
                    reserveAndPickupClick={fulfillment.selectPickup}
                    reserveAndPickup={fulfillment.selectedMethod === 'pickup'}
                    autoReplenishClick={commerce.autoReplenishClick}
                    autoReplenishChecked={commerce.autoReplenishChecked}
                    isAutoReplenMostCommon={commerce.isAutoReplenMostCommon}
                    replenishmentFreqNum={commerce.replenishmentFreqNum}
                    replenishmentFreqType={commerce.replenishmentFreqType}
                    quantity={commerce.quantity}
                    openDeliveryFrequencyModal={commerce.toggleDeliveryFrequencyModal}
                    skuTrialEligibility={fulfillment.skuTrialEligibility}
                    skuTrialPeriod={fulfillment.skuTrialPeriod}
                    isUserSDUTrialEligible={fulfillment.isUserSDUTrialEligible}
                    resetGetItShipped={fulfillment.resetGetItShipped}
                />
            )}
            {!currentSku?.isOutOfStock && !showSocialProofPDP.control && showSocialProofPDP.challengerTwo && (
                <Media lessThan='md'>
                    <Box marginTop={3}>
                        <ProductViewsCount
                            blackBackground
                            unlockWidth
                        />
                    </Box>
                </Media>
            )}
            {commerce.isFrequencyModalOpen && (
                <DeliveryFrequencyModal
                    isOpen={commerce.isFrequencyModalOpen}
                    onDismiss={() => commerce.toggleDeliveryFrequencyModal(false)}
                    title={getAutoReplenText('deliveryFrequency')}
                    currentProduct={currentProduct}
                    replenishmentFreqNum={parseInt(commerce.replenishmentFreqNum)}
                    replenishmentFreqType={commerce.replenishmentFreqType}
                    quantity={commerce.quantity}
                    updateFrequencyModal={commerce.updateFrequencyModal}
                    isBasket={false}
                />
            )}
        </>
    );
};

export default wrapFunctionalComponent(FulfillmentSection, 'FulfillmentSection');
